/* eslint-disable */
import { memo, useState } from 'react';
import { Link } from 'react-router-dom';
import { BsFillGearFill } from 'react-icons/bs';
import {
  MdClose, MdNavigateNext, MdLogin, MdLogout,
} from 'react-icons/md';
import {
  Avatar,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from '../../redux/actions/auth';
import LinkList from './link-list-store';
import LogoCircle from './logo-circle';
import API_URL from '../../services';

const SideNavLinks = () => (
  LinkList.map((value) => (
    <NavLink id={value.id} name={value.name} url={value.url} icon={value.icon} key={value.name} />
  ))
);

const NavLink = ({
  id, url, name,
}) => (
  <li key={`${id}&${name}`} className="flex w-[90%] text-gray-300">
    <Link to={`${url}`} className="flex justify-between w-full font-serif">
      <div className="flex gap-1 items-center">
        {name}
      </div>
      <MdNavigateNext className="text-gray-300" size={25} />
    </Link>
  </li>
);

function MobileNav({ handleMenuBtn, navBarValue }) {
  const { isLoggedIn, user: userData } = useSelector((state) => state.auth);
  const { user: userInformation } = userData
    ? userData : { user: { full_name: null, profile_image: null, role: null }};
  const { full_name: fullName, profile_image: profileImageURL, role: userRole } = userInformation;
  const dispatch = useDispatch();
  const logOut = () => {
    dispatch(logout());
  };

  const AuthStatus = () => {
    if (!isLoggedIn) {
      return (
        <li key="4auth" className="flex w-[90%] text-gray-300">
          <Link to="accounts/login" className="flex justify-between w-full font-serif">
            <div className="flex gap-1 items-center">
              Login
            </div>
            <MdLogin className="text-gray-300 mr-2" size={18} />
          </Link>
        </li>
      );
    }
    return (
      <li key="4auth" className="flex w-[90%] text-gray-300">
        <a href="/" className="flex justify-between w-full font-serif" onClick={logOut}>
          <div className="flex gap-1 items-center">
            Logout
          </div>
          <MdLogout className="text-gray-300 mr-2" size={18} />
        </a>
      </li>
    );
  };

  return (
    <nav className="transition-all duration-500 ease-in flex flex-col h-[95%] gap-5">
      <div className="bg-white rounded-b-xl">
        <div className="flex justify-end h-10 items-center mr-3 mt-2">
          <MdClose className="text-gray-300" size={30} onClick={() => handleMenuBtn()} />
        </div>
        {!isLoggedIn && (<LogoCircle navBarValue={navBarValue} />) }
        {isLoggedIn && (
          <div className={`flex flex-col py-5 pl-5 gap-3 ${navBarValue ? 'scale-100' : 'scale-0'}`}>
            <Avatar
              alt="user"
              src={`${API_URL}/${profileImageURL}`}
              className="object-scale-down"
              sx={{ width: 90, height: 90 }}
            />
            <div className="flex flex-col">
              <span className="font-serif font-bold text-main capitalize">{fullName}</span>
              <div className="flex justify-between pr-2">
                <span className="font-serif italic text-sm font-normal">{userRole}</span>
                <Link to="dashboard">
                  <span className="text-main flex items-center gap-2">
                    <BsFillGearFill />
                    Setting
                  </span>
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>
      <ul className={`flex flex-col h-full items-center justify-start gap-4 ${navBarValue ? 'scale-100' : 'scale-0'}`}>
        <SideNavLinks />
        <AuthStatus />
      </ul>
      <hr className="text-white w-[90%] self-center mb-3" />
      <div
        className={`px-3 flex flex-col mb-2 text-white items-center
                justify-between gap-3 ${navBarValue ? 'scale-100' : 'scale-0'}`}
      >
        <span className="text-sm sm:text-center">
          <a href="http://localhost" className="ml-1 hover:underline">Medstore Trading PLC™</a>
          © 2022
        </span>
        <div className="flex gap-2">
          <p>
            Powered by:
            <a href="www.debolx.com" className="italic"> Debolx</a>
          </p>
        </div>
      </div>
    </nav>
  );
}

MobileNav.propTypes = {
  handleMenuBtn: PropTypes.func.isRequired,
  navBarValue: PropTypes.bool.isRequired,
};

NavLink.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default memo(MobileNav);
